import { find, getOr } from 'lodash/fp';

import { PARTNER_AUTHORISATION_OPTIONS } from '../../field-components/constants';

const getPartnerAuthText = (value: string) => {
  const findByValue = find({ value });
  const option = findByValue(PARTNER_AUTHORISATION_OPTIONS);
  return getOr(' ', 'text', option);
};

export default getPartnerAuthText;
